import { withTranslation } from "react-i18next";
import TourLineContent from './TourLineContent';

export default withTranslation()(TourLineContent);